class NappiFreeShipping extends HTMLElement {
  static observedAttributes = ["data-total-cents", "data-threshold-shop-cents"];
  connectedCallback() {
    this.render();
  }
  attributeChangedCallback() {
    if (this.isConnected) this.render();
  }
  get gabarit() {
    const temoin = this.dataset.moneySample;
    if (this._temoin !== temoin) {
      this._temoin = temoin;
      this._gabarit = window.NappiMoney?.gabarit(temoin) || null;
    }
    return this._gabarit;
  }
  render() {
    const money = window.NappiMoney;
    if (!money) return;
    const total = Number(this.dataset.totalCents);
    const seuil = money.seuil({
      seuilBoutique: this.dataset.thresholdShopCents,
      devisePanier: this.dataset.cartCurrency,
      deviseBoutique: this.dataset.shopCurrency
    });
    const connu = seuil !== null && Number.isFinite(total);
    const atteint = connu && total >= seuil;
    if (this.dataset.variant === "row") {
      this.#renderRow(connu, atteint);
    } else {
      this.#renderBar(connu, atteint, total, seuil);
    }
  }
  #renderRow(connu, atteint) {
    const valeur = this.querySelector("[data-value]");
    if (!valeur) return;
    let texte = this.dataset.pendingLabel;
    if (!atteint && connu && this.gabarit) {
      const frais = window.NappiMoney.seuil({
        seuilBoutique: this.dataset.feeShopCents,
        devisePanier: this.dataset.cartCurrency,
        deviseBoutique: this.dataset.shopCurrency
      });
      if (frais) texte = window.NappiMoney.formater(frais, this.gabarit);
    }
    valeur.textContent = atteint ? this.dataset.freeLabel : texte;
    valeur.toggleAttribute("data-free", atteint);
  }
  #renderBar(connu, atteint, total, seuil) {
    const inner = this.querySelector("[data-inner]");
    const message = this.querySelector("[data-msg]");
    const fill = this.querySelector("[data-fill]");
    const track = this.querySelector('[role="progressbar"]');
    if (!inner || !message || !fill) return;
    let texte = null;
    if (atteint) {
      texte = this.dataset.unlockedMessage;
    } else if (connu && this.gabarit) {
      let reste = Math.max(0, seuil - total);
      if (!this.gabarit.sepDec) reste = Math.ceil(reste / 100) * 100;
      texte = (this.dataset.message || "").split("[amount]").join(window.NappiMoney.formater(reste, this.gabarit));
    }
    if (!texte) {
      inner.hidden = true;
      return;
    }
    const progression = atteint ? 100 : Math.min(100, Math.max(0, total * 100 / seuil));
    message.textContent = texte;
    inner.toggleAttribute("data-unlocked", atteint);
    fill.style.width = `${progression}%`;
    track?.setAttribute("aria-valuenow", String(Math.round(progression)));
    inner.hidden = false;
  }
}
if (!customElements.get("nappi-free-shipping")) {
  customElements.define("nappi-free-shipping", NappiFreeShipping);
}
